module.exports = __webpack_public_path__ + "static/media/whatsapp_guide_mobile_01.1dee9ff8.svg";